import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import DataTable from "../../../pagecomponents/Common/DataTable";
import { ToastContainer } from "react-toastify";
import { toastMessage } from "../../../helpers/utility.js";
import ModalWrapper from "../../../pagecomponents/Common/ModalWrapper";
import {
  getData,
  deleteData,
  printData,
} from "../../../redux/slices/VoucherSlice.js";
import ReceiptVchAddEdit from "./AddEditForm.js";
import Swal from "sweetalert2";
import { Row, InputGroup, Button } from "react-bootstrap";
import { CCol, CFormLabel, CFormInput } from "@coreui/react";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { getCustomerData } from "../../../redux/slices/CustomerSlice";
import useDebouncedValue from "../../../helpers/useDebouncedValue";

const ReceiptVoucherIndex = () => {
  const dispatch = useDispatch();
  const pageName = "Receipt Voucher";

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [totalPage, setTotalPage] = useState(0);

  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
    search_Id: "",
    search_Name: "",
    search_Type: "Customer",
  });

  const LIST_PARAMS = {
    skip: 0,
    take: rowsPerPage,
    voucher_Type: "Receipt",
    filter: {},
  };

  const [data, setData] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [params, setParams] = useState(LIST_PARAMS);
  const [isEdit, setIsEdit] = useState(false);
  const [editData, setEditData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const debouncedSearchName = useDebouncedValue(filters.search_Name, 350);

  useEffect(() => {
    getComponentData();
  }, [params]);

  useEffect(() => {
    const searchValue = String(debouncedSearchName || "").trim();
    if (!searchValue || filters.search_Id) {
      setSuggestions([]);
      return;
    }

    let isMounted = true;
    const fetchSuggestions = async () => {
      try {
        const requestParams = {
          skip: 0,
          take: 1000,
          searchStr: searchValue,
          sorting: "asc",
          sorting_key: "created_at",
          filter: {},
          useLookupApi: true,
        };
        const { payload } = await dispatch(getCustomerData({ inputData: requestParams }));
        if (isMounted) {
          setSuggestions(Array.isArray(payload?.data) ? payload.data : []);
        }
      } catch (error) {
        if (isMounted) {
          setSuggestions([]);
        }
      }
    };

    fetchSuggestions();
    return () => {
      isMounted = false;
    };
  }, [debouncedSearchName, filters.search_Id, dispatch]);

  const handleGetData = () => {
    setParams((prevParams) => ({
      ...prevParams,
      filter: filters, // Update filter only on button click
    }));
  };

  const getComponentData = async () => {
    setIsLoading(true);
    setModalVisible(false);

    try {
      const { payload } = await dispatch(getData({ inputData: params }));
      setData(payload?.data);
      setTotalPage(Math.ceil(payload?.count / rowsPerPage));
    } catch (err) {
      toastMessage("error", "Failed to fetch data");
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  const openModal = () => {
    setModalVisible(true);
    setIsEdit(false);
  };

  const closeModal = () => {
    setModalVisible(false);
    setIsEdit(false);
  };

  const openEditModal = (item) => {
    setModalVisible(true);
    setIsEdit(true);
    setEditData(item);
  };

  // const handleSort = (key) => {
  //     setParams((prev) => ({
  //         ...prev,
  //         sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
  //         sorting_key: key,
  //     }));
  // };
  const handelPrint = async (e) => {
    // console.log("the item data is ", e);

    const postData = {
      voucherId: e.voucher_Id,
      reportType: "Receipt",
    };
    // setIsLoading(true);

    try {
      const { payload } = await dispatch(printData({ inputData: postData }));
      //   console.log("response data is", payload);

      if (payload?.status === "success" && payload?.data) {
        const pdfUrl = payload.data;
        window.open(pdfUrl, "_blank"); // Open in new tab
        // const pdfUrl = payload.data;
        // window.open(pdfUrl, "_blank");
        // const link = document.createElement("a");
        // link.href = pdfUrl;
        // link.download = `Receipt_Voucher_${Date.now()}.pdf`;
        // document.body.appendChild(link);
        // link.click();
        // document.body.removeChild(link);
      } else {
        toastMessage("error", "Invalid response from server");
      }
    } catch (err) {
      toastMessage("error", "Failed to fetch data");
    } finally {
      //   setIsLoading(false);
    }
  };

  const handleSort = (key) => {
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      skip: 0,
      sorting_key: key,
      sorting:
        prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
    }));
  };

  const handleRowsPerPageChange = (rows) => {
    setRowsPerPage(rows);
    setCurrentPage(1);

    setParams((prev) => ({
      ...prev,
      take: rows,
      skip: 0,
    }));
  };

  const setPage = (pagenum) => {
    setCurrentPage(pagenum);
    setParams((prev) => ({
      ...prev,
      skip: (pagenum - 1) * prev.take,
    }));
  };

  const handleDelete = async (item) => {
    console.log(item);
    let params = {
      voucher_Id: item.voucher_Id,
      type: "delete",
    };

    const { payload } = await dispatch(deleteData({ inputData: params }));
    if (payload?.status === "success") {
      Swal.fire("Deleted!", "Your file has been deleted.", "success");
      getComponentData();
    } else {
      toastMessage("error", payload.msg || "An error occurred while saving.");
    }
  };

  const columns = [
    { label: "Date", accessor: "voucher_Date", sortable: true },
    { label: "Customer", accessor: "voucher_payment_Name", sortable: true },
    { label: "Vch No", accessor: "voucher_No", sortable: true },
    { label: "Vch Type", accessor: "voucher_Type", sortable: true },
    { label: "Amount", accessor: "voucher_Total_Amount", sortable: true },
  ];

  const handleAutoComplete = (e) => {
    const { value } = e.target;

    setFilters((prevFilters) => ({
      ...prevFilters,
      search_Name: value,
      search_Id: "",
    }));
    if (value.trim() === "") {
      setSuggestions([]);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target || {};

    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value
        ? name === "start_date"
          ? format(value, "yyyy-MM-dd") + " 00:00:00"
          : name === "end_date"
          ? format(value, "yyyy-MM-dd") + " 23:59:59"
          : value
        : "",
    }));
  };

  const setCustomerData = (customerData) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      search_Name: customerData?.customer_Name || "",
      search_Id: customerData?.customer_Id,
    }));

    setSuggestions([]); // Clear suggestions
  };

  const handleResetFilters = () => {
    setFilters({
      start_date: "",
      end_date: "",
      search_Id: "",
      search_Name: "",
      search_Type: "Ledger",
    });

    // Ensure the API call happens after state update
    setTimeout(() => {
      setParams((prevParams) => ({
        ...prevParams,
        filter: {}, // Use the updated filters
      }));
    }, 0);
  };

  //   console.log("my data is ", data);
  return (
    <>
      <ToastContainer />
      <PageWrapper
        pageName={pageName}
        headerBtnTitle="+ Receipt Voucher"
        onHeaderButtonClick={() => openModal()}
        showAddBtn={true}
      >
        <Row className="row-xs mb-4">
          <CCol md={3}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="invoice_Date"
            >
              From Date
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="start_date"
                id="start_date"
                selected={
                  filters.start_date ? new Date(filters.start_date) : null
                } // Convert to Date object
                onChange={(date) => {
                  const event = {
                    target: {
                      name: "start_date",
                      value: date,
                    },
                  };
                  handleInputChange(event); // Simulate an event for compatibility
                }}
                dateFormat="yyyy-MM-dd" // Match the desired format
                // isClearable // Optional: Allow clearing the date
              />
            </InputGroup>
          </CCol>
          <CCol md={3}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="end_date"
            >
              To Date
            </CFormLabel>
            <InputGroup className="input-group reactdate-pic">
              <InputGroup.Text className="input-group-text">
                <i className="typcn typcn-calendar-outline tx-24 lh--9 op-6"></i>
              </InputGroup.Text>
              <DatePicker
                className="form-control"
                name="end_date"
                id="end_date"
                selected={filters.end_date ? new Date(filters.end_date) : null} // Convert to Date object
                onChange={(date) => {
                  const event = {
                    target: {
                      name: "end_date",
                      value: date,
                    },
                  };
                  handleInputChange(event); // Simulate an event for compatibility
                }}
                dateFormat="yyyy-MM-dd" // Match the desired format
                // isClearable // Optional: Allow clearing the date
              />
            </InputGroup>
          </CCol>
          <CCol md={4}>
            <CFormLabel
              className="main-content-label tx-11 tx-medium tx-gray-600"
              htmlFor="search_Name"
            >
              Select Customer
            </CFormLabel>
            <div className="hsc-wrapper">
              <InputGroup className="input-group">
                <CFormInput
                  type="text"
                  id="search_Name"
                  name="search_Name"
                  value={filters.search_Name}
                  onChange={handleAutoComplete}
                  required
                />
              </InputGroup>
              {suggestions && suggestions.length > 0 && (
                <div
                  className="header-search-container"
                  onMouseDown={(e) => e.preventDefault()}
                  onPointerDown={(e) => e.preventDefault()}
                >
                  <div className="hs">
                    {suggestions?.map((suggestion, index) => (
                      <div
                        key={suggestion?.customer_Id || index}
                        className="main-message-list header-search-element"
                        onPointerDown={(e) => {
                          e.preventDefault();
                          setCustomerData(suggestion);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <strong>
                          {suggestion?.customer_Name} -{" "}
                          {suggestion?.customer_Code}{" "}
                        </strong>
                        <span>{suggestion?.customer_Email}</span>
                        <span>{suggestion?.customer_Mobile}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </CCol>
          <CCol
            md={2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "left",
              paddingTop: "28px",
              paddingLeft: "20px",
            }}
          >
            <Row className="btn-animation">
              <Button
                variant=""
                type="button"
                className={`btn btn-sm btn-primary ms-2`}
                onClick={() => {
                  handleGetData();
                }}
              >
                Get Data
              </Button>
              <Button
                variant=""
                type="button"
                className="btn btn-sm btn-primary ms-2"
                onClick={handleResetFilters}
              >
                Reset
              </Button>
            </Row>
          </CCol>
        </Row>
        <DataTable
          data={data}
          columns={columns}
          onEdit={openEditModal}
          onDelete={handleDelete}
          onSorting={handleSort}
          onPrint={handelPrint}
          sortingState={{ key: params.sorting_key, order: params.sorting }}
          currentPage={currentPage}
          totalPages={totalPage}
          rowsPerPage={rowsPerPage}
          updateRowsPerPage={handleRowsPerPageChange}
          onPageChange={setPage}
          loader={isLoading}
          pageName="Voucher"
        />
      </PageWrapper>

      <ModalWrapper
        visible={modalVisible}
        onClose={() => closeModal()}
        modalTitle={isEdit ? "Edit " + pageName : "Add " + pageName}
        modalSize={"lg"}
      >
        <ReceiptVchAddEdit
          invisible={closeModal}
          loadData={getComponentData}
          mode={isEdit}
          editData={editData}
        />
      </ModalWrapper>
    </>
  );
};

export default ReceiptVoucherIndex;
